import { DataTable } from '@root/shared/ui-kit'
import { isNoAccessError } from '@root/shared/ui-kit'

import { DataTableMessageLogin } from './app-data-table-message-login'

import type { TypeHelper } from '@blade/std-lib'
import type { DataTableProps, InfoMessage } from '@root/shared/ui-kit'

type AppDataTableProps<
  D extends object,
  ColumnId extends string = string,
  Context extends object | undefined = undefined,
> = TypeHelper.OmitKey<DataTableProps<D, ColumnId, Context>, 'renderError'> & {
  renderError?: () => React.ReactElement<typeof InfoMessage>
}

export const AppDataTable = <
  D extends object,
  ColumnId extends string = string,
  Context extends object | undefined = undefined,
>({
  renderError,
  ...props
}: AppDataTableProps<D, ColumnId, Context>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tableProps = props as DataTableProps<any, string, any>
  return (
    <DataTable
      {...tableProps}
      renderError={(error) => {
        if (isNoAccessError(error)) {
          return <DataTableMessageLogin />
        }
        if (renderError) {
          return renderError()
        }
      }}
    />
  )
}
